var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import Portal from '../Portal/Portal';
import GlobalClickGuard from "../GlobalClickGuard";
import * as S from "./index.module.css";
import classNames from "../../../lib/utils/classNames";
import { NO_OP } from "../../../lib/utils/consts";
function posDist(pos1, pos2) {
  return Math.sqrt((pos1.x - pos2.x) ** 2 + (pos1.y - pos2.y) ** 2);
}
let ContextMenu = class ContextMenu extends Vue {
  constructor() {
    super(...arguments);
    this.visible = false;
    this.left = 0;
    this.top = 0;
    this.disableRight = false;
    this.hidden = false;
    this.reverse = false;
  }
  open(ev, {
    parent
  }) {
    this.left = ev.clientX;
    this.top = ev.clientY;
    this.disableRight = window.innerWidth - this.left < 150;
    this.visible = true;
    this.reverse = false;
    this.hidden = false;
    // 先渲染 但是不可见 渲染后测量高度 再决定top弹出还是bottom弹出
    if (!parent) return;
    this.hidden = true;
    this.$nextTick(() => {
      const sectAreas = Object.entries(this.$refs).map(([key, value]) => key.startsWith('sectArea') && value).filter(Boolean);
      const bottom = Math.max(...sectAreas.map(div => div.getBoundingClientRect().bottom));
      const parentBottom = parent.getBoundingClientRect().bottom;
      if (bottom - parentBottom > 50) {
        this.reverse = true;
      }
      this.hidden = false;
    });
  }
  get wrapperStyle() {
    const base = `left:${this.left}px; top:${this.top}px;`;
    const hidden = this.hidden ? 'visibility:hidden' : '';
    return base + hidden;
  }
  close() {
    if (!this.visible) return;
    this.visible = false;
    this.$emit('close');
  }
  handleSectionClick(ev) {
    // 展开菜单后在展开菜单的点附近左键/右键单击同样可以关闭菜单
    if (posDist(ev, {
      x: this.left,
      y: this.top
    }) < 12) {
      this.close();
    }
  }
  handleSectionContextmenu(ev) {
    this.handleSectionClick(ev);
    ev.preventDefault();
  }
  render() {
    const h = arguments[0];
    if (!this.visible) return null;
    if (!this.content) {
      this.visible = false;
      return null;
    }
    const sectionAreas = [[], [], [], []];
    if (this.disableRight) {
      sectionAreas[1] = sectionAreas[0];
      sectionAreas[3] = sectionAreas[2];
    }
    this.content.filter(sect => sect.items.length).forEach((sect, sectKey) => {
      const section = h("div", {
        "on": {
          "click": this.handleSectionClick,
          "contextmenu": this.handleSectionContextmenu
        }
      }, [h("div", {
        "class": S.menuSection,
        "key": sectKey,
        "attrs": {
          "data-index": sectKey
        }
      }, [h("div", {
        "class": S.menuSectionTitle
      }, [sect.title]), h("div", {
        "class": S.menuItemList
      }, [sect.items.map((item, k) => h(MenuItem, {
        "key": k,
        "attrs": {
          "item": item,
          "owner": this
        }
      }))])])]);
      const areaId = sectKey % 4;
      sectionAreas[areaId].push(section);
    });
    if (this.disableRight) {
      sectionAreas[0] = [];
      sectionAreas[2] = [];
    }
    return h(Portal, [h(GlobalClickGuard, {
      "on": {
        "cancel": this.close
      },
      "attrs": {
        "listenEvent": 'down'
      },
      "class": classNames(S.wrapper, this.reverse && S.reverse),
      "style": this.wrapperStyle
    }, [sectionAreas.map((a, i) => a.length ? h("div", {
      "ref": `sectArea${i}`,
      "class": S.menuSectionArea,
      "key": `sectArea${i}`,
      "attrs": {
        "data-index": i
      }
    }, [a]) : null)])]);
  }
};
__decorate([Prop({
  type: Array,
  default: null
})], ContextMenu.prototype, "content", void 0);
ContextMenu = __decorate([Component({})], ContextMenu);
export { ContextMenu };
let MenuItem = class MenuItem extends Vue {
  constructor() {
    super(...arguments);
    this.isBusy = false;
  }
  async handleClick() {
    if (this.isBusy) return;
    this.isBusy = true;
    try {
      var _this$item$execute, _this$item;
      await ((_this$item$execute = (_this$item = this.item).execute) === null || _this$item$execute === void 0 ? void 0 : _this$item$execute.call(_this$item));
    } catch (e) {
      console.error('MenuItem Error', e);
    }
    this.isBusy = false;
    this.owner.close();
  }
  render() {
    const h = arguments[0];
    const {
      item
    } = this;
    const isDisabled = !item.execute;
    const isSeparator = /^--+$|^\|$/.test(String(item.title));
    if (isSeparator) {
      return h("div", {
        "class": S.menuItemSeparator
      });
    }
    // 对齐macos chrome 菜单上的右键点击同样生效
    return h("div", {
      "class": classNames(S.menuItem, isDisabled && S.isDisabled, this.isBusy && S.isBusy),
      "attrs": {
        "title": item.desc,
        "tabIndex": isDisabled ? -1 : 0
      },
      "on": {
        "click": this.handleClick,
        "contextmenu": this.handleClick,
        "mouseenter": item.onMouseEnter || NO_OP,
        "mouseleave": item.onMouseLeave || NO_OP
      }
    }, [h("div", {
      "class": classNames(S.checkMark, !item.checked && S.isHidden)
    }), !!item.icon && h("span", {
      "class": item.icon
    }), h("div", {
      "class": S.itemText
    }, [item.title])]);
  }
};
__decorate([Prop()], MenuItem.prototype, "item", void 0);
__decorate([Prop()], MenuItem.prototype, "owner", void 0);
MenuItem = __decorate([Component({})], MenuItem);
//# sourceMappingURL=index.js.map
